import React, { useState } from 'react';
import { Box, TextField, Button, Stack, CircularProgress, alpha } from '@mui/material';
import { SaveOutlined, CloseOutlined } from '@mui/icons-material';
import { createMeasurements } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification'; // Assuming you use this helper
import { message } from 'antd'; // Keeping antd message for consistency if preferred
import '../style.css';

const AddMeasurementForm = ({ closeModal, reload }) => {
  const [loading, setLoading] = useState(false);
  const [measurementName, setMeasurementName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!measurementName.trim()) return;

    setLoading(true);
    const payload = {
      measurementName: measurementName.trim().toLowerCase(),
      parameters: [],
    };

    createMeasurements(payload)
      .then((res) => {
        setLoading(false);
        message.success(`New Measurement Type "${measurementName}" created successfully!`);
        reload();
        closeModal();
      })
      .catch((error) => {
        const responseMessage = error?.data?.result?.status?.desc || 'Something went wrong';
        setLoading(false);
        message.error(responseMessage);
      });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
      <Stack spacing={3}>
        <TextField
          fullWidth
          label="Measurement Name"
          placeholder="e.g. Air Quality, Water Effluent"
          variant="outlined"
          value={measurementName}
          onChange={(e) => setMeasurementName(e.target.value)}
          required
          autoFocus
          disabled={loading}
          slotProps={{
            input: {
              sx: { borderRadius: '10px' },
            },
          }}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
          <Button
            variant="text"
            color="inherit"
            onClick={closeModal}
            disabled={loading}
            startIcon={<CloseOutlined />}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              px: 3,
            }}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="contained"
            disableElevation
            disabled={loading || !measurementName.trim()}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <SaveOutlined />}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              px: 4,
              bgcolor: 'primary.main',
              '&:hover': { bgcolor: 'primary.dark' },
            }}
          >
            {loading ? 'Saving...' : 'Save Measurement'}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AddMeasurementForm;
